import declareEnterpriseApi from "@/api/DeclareEnterpriseApi";

const declareEnterpriseStore = {
  namespaced: true,
  state: {
    enterpriseTypeGroup: {},
    assureEnterprise: [],
  },
  mutations: {
    setDeclareEnterpriseList(state, data) {
      state.enterpriseTypeGroup = data;
    },
    setAssureEnterprise(state, data) {
      state.assureEnterprise = data;
    },
  },
  actions: {
    add(ctx, data) {
      return declareEnterpriseApi.add(data).then((res) => {
        ctx.dispatch("listAllDeclareEnterprise", { isUpdate: true });
        return res;
      });
    },

    edit(ctx, data) {
      return declareEnterpriseApi.edit(data).then((res) => {
        ctx.dispatch("listAllDeclareEnterprise", { isUpdate: true });
        return res;
      });
    },

    listDeclareEnterprise(ctx, data) {
      return declareEnterpriseApi.listDeclareEnterprise(data);
    },
    listAllDeclareEnterprise(ctx, data) {
      data = data || {};
      if (
        !data.isUpdate &&
        Object.keys(ctx.state.enterpriseTypeGroup).length > 0
      ) {
        return Promise.resolve(ctx.state.enterpriseTypeGroup);
      }
      let searchCondition = {
        request: JSON.stringify({
          pageInfo: {
            pageIndex: 1,
            pageSize: 100000,
          },
        }),
      };
      ctx.dispatch("listDeclareEnterprise", searchCondition).then((res) => {
        let enterpriseTypeGroup = {};
        let assureEnterprise = [];
        res.items.forEach((item) => {
          let enterprise = {
            value: item.enterpriseNid,
            label: item.enterpriseName,
          };
          (enterpriseTypeGroup[item.enterpriseType] =
            enterpriseTypeGroup[item.enterpriseType] || []).push(enterprise);
          assureEnterprise.push({
            value: item.enterpriseCustomsCode,
            label: item.enterpriseName,
          });
        });
        ctx.commit("setAssureEnterprise", assureEnterprise);
        ctx.commit("setDeclareEnterpriseList", enterpriseTypeGroup);
        return enterpriseTypeGroup;
      });
    },

    bindConfChannel(ctx, data) {
      return declareEnterpriseApi.bindConfChannel(data).then((res) => {
        return res;
      });
    },

    listChannelEnterprise(ctx, data) {
      return declareEnterpriseApi.listChannelEnterprise(data).then((res) => {
        return res;
      });
    },
  },
};

export default declareEnterpriseStore;
